import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Icon } from '@/src/elements/media/Icon'
import { Typography } from '@/src/elements/text/Typography'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { useTranslate } from '@/src/lang/useTranslate'

type TIframeErrorProps = {
  onRetry: () => void
}

export const IframeError = ({ onRetry }: TIframeErrorProps): ReactNode => {
  const { t } = useTranslate()

  return (
    <View
      testID={TEST_ID.MISCELLANEOUS.IFRAME_ERROR}
      className="h-full w-full flex-1 items-center justify-center gap-6 bg-white px-8"
    >
      <Icon name={ICON.ALERT_TRIANGLE} className="h-16 w-16 color-secondary-label-faded" />
      <View className="items-center gap-2">
        <Typography bold center size="lg">
          {t('iframe.error.title')}
        </Typography>
        <Typography center>{t('iframe.error.description')}</Typography>
      </View>
      <Button colors="primary" onPress={onRetry} testID={TEST_ID.MISCELLANEOUS.IFRAME_ERROR_RETRY}>
        {t('tab.error.try-again')}
      </Button>
    </View>
  )
}
